import script from "./About.vue?vue&type=script&setup=true&lang=js"
export * from "./About.vue?vue&type=script&setup=true&lang=js"

import "./About.vue?vue&type=style&index=0&id=1be97a25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be97a25"]])

export default __exports__